import React from "react";
import { SVG, IconProps } from "../SVG";
export const FunctionalSparkle = ({
    color = "#13126C",
    strokeWidth = "5",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 56 56" {...props}>
        <path
            stroke={color}
            strokeLinecap="round"
            strokeWidth={strokeWidth}
            d="M16.333 4.667V14M11.667 9.333H21M9.333 42v9.333M4.667 46.667H14M32.667 9.333C32.667 19.6 26.133 28 14 28M32.667 9.333C32.667 19.6 39.2 28 51.333 28M14 28c10.267 0 18.667 6.533 18.667 18.667M51.333 28c-10.266 0-18.666 6.533-18.666 18.667"
        />
    </SVG>
);
FunctionalSparkle.displayName = "FunctionalSparkle";
